import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/* -------------------- GET ALL CONTACT ENQUIRIES -------------------- */
export const getAllContactEnquiriesThunk = createAsyncThunk(
  "contactUs/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get("/api/admin/contactus/list");
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch contact enquiries"
      );
    }
  }
);

/* -------------------- GET SINGLE CONTACT ENQUIRY -------------------- */
export const getSingleContactEnquiryThunk = createAsyncThunk(
  "contactUs/getSingle",
  async (uuid, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/api/admin/contactus/show?uuid=${uuid}`);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch contact enquiry"
      );
    }
  }
);

/* -------------------- ADD CONTACT ENQUIRY -------------------- */
export const addContactEnquiryThunk = createAsyncThunk(
  "contactUs/add",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/api/contactus/add", formData);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to add contact enquiry"
      );
    }
  }
);

/* -------------------- UPDATE CONTACT ENQUIRY -------------------- */
export const updateContactEnquiryThunk = createAsyncThunk(
  "contactUs/update",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/api/admin/contactus/update", formData);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to update contact enquiry"
      );
    }
  }
);

/* -------------------- DELETE CONTACT ENQUIRY -------------------- */
export const deleteContactEnquiryThunk = createAsyncThunk(
  "contactUs/delete",
  async (uuid, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/api/admin/contactus/delete?uuid=${uuid}`);

      return {
        uuid,
        message: res.data?.message || "Deleted successfully",
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to delete contact enquiry"
      );
    }
  }
);
